import { Category } from "@/shared/v2/queries/interfacesV2";
import { Link } from "react-router-dom";
import EmptyImage from "../../../App/Assets/Images/empty.png";
import { withCloudinaryBackgroundRemoval } from "@/shared/utils/helpers";

interface KioskCatProps {
  category: Category;
  isSelected?: boolean;
  deliveryMethod: string;
}

const KioskCat = ({
  deliveryMethod,
  category,
  isSelected = false,
}: KioskCatProps) => {
  const img = category?.image_cloudinary_id ?? "";
  const image = img
    .replace("w_584", "w_300")
    .replace("h_136", "h_200");
  return (
    <Link to={`/kiosk/menu/${deliveryMethod}/${category?.item_id}`}>
      <div
        className="flex flex-col justify-center cursor-pointer items-center gap-4 rounded-3xl p-[2rem_3rem]"
        style={{
          background: isSelected
            ? "var(--button_background_color)"
            : "var(--category_background_color)",
        }}
      >
        <img
          src={withCloudinaryBackgroundRemoval(image)}
          decoding="async"
          onError={(e: any) => (e.target.src = EmptyImage)}
          className="w-280 h-40 object-contain"
        />
        <div
          className="text-[1.75rem]"
          style={{
            color: isSelected
              ? "var(--button_text_color)"
              : "var(--category_text_color)",
            fontWeight: "900",
          }}
        >
          {category.name}
        </div>
      </div>
    </Link>
  );
};

export default KioskCat;
